var _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebsiteSetupProject2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.78,163.27H99.14V76.63H225.78Zm-125.64-1H224.78V77.63H100.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.05,82.21a2.52,2.52,0,1,1-2.52-2.52A2.52,2.52,0,0,1,109.05,82.21Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.34,82.21a2.52,2.52,0,1,1-2.52-2.52A2.52,2.52,0,0,1,119.34,82.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.63,82.21a2.52,2.52,0,1,1-2.52-2.52A2.52,2.52,0,0,1,129.63,82.21Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.64,
    y: 86.65,
    width: 125.64,
    height: 1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M683.57,205.19l5.89-9.49-2.91-1.8a2.62,2.62,0,0,1-1.23-2.49c0-.56.06-1.12,0-1.67a2.65,2.65,0,0,1,1.38-2.41l3-1.62-5.28-9.84-3,1.61a2.66,2.66,0,0,1-2.77-.18,16,16,0,0,0-1.42-.88,2.66,2.66,0,0,1-1.4-2.41l.11-3.41-11.16-.35-.11,3.43a2.65,2.65,0,0,1-1.55,2.31l-.74.37-.71.41a2.68,2.68,0,0,1-2.77,0L656,175l-5.89,9.49,2.91,1.81a2.64,2.64,0,0,1,1.23,2.5,15.34,15.34,0,0,0,0,1.66,2.64,2.64,0,0,1-1.39,2.41l-3,1.62,5.28,9.84,3-1.61a2.64,2.64,0,0,1,2.77.17,16,16,0,0,0,1.42.88,2.66,2.66,0,0,1,1.4,2.41l-.1,3.42,11.16.35.11-3.43a2.64,2.64,0,0,1,1.55-2.3l.74-.37.71-.41a2.67,2.67,0,0,1,2.79,0Zm-9.45-7a9.15,9.15,0,1,1,3.74-12.39A9.15,9.15,0,0,1,674.12,198.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.78,97.89l-3.91-6.78-2.08,1.2a1.85,1.85,0,0,1-2-.07,9.12,9.12,0,0,0-1-.58,1.86,1.86,0,0,1-1-1.66V87.61H266V90a1.86,1.86,0,0,1-1,1.66,10.29,10.29,0,0,0-1,.58,1.85,1.85,0,0,1-1.95.07l-2.07-1.2L256,97.89l2.08,1.2a1.85,1.85,0,0,1,.91,1.72c0,.19,0,.39,0,.58s0,.38,0,.57a1.86,1.86,0,0,1-.9,1.72L256,104.89l3.91,6.78,2.08-1.2a1.83,1.83,0,0,1,1.95.07,11,11,0,0,0,1,.58,1.86,1.86,0,0,1,1,1.65v2.4h7.83v-2.4a1.85,1.85,0,0,1,1-1.65c.35-.18.68-.37,1-.58a1.83,1.83,0,0,1,2-.07l2.08,1.2,3.91-6.78-2.08-1.2a1.85,1.85,0,0,1-.91-1.72c0-.19,0-.39,0-.58s0-.39,0-.58a1.87,1.87,0,0,1,.91-1.73Zm-7.48,3.5A6.41,6.41,0,1,1,269.89,95,6.4,6.4,0,0,1,276.3,101.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,267.7a30.48,30.48,0,1,0,30.47,30.48A30.47,30.47,0,0,0,98,267.7Zm0,44.7a14.23,14.23,0,1,1,14.24-14.22A14.22,14.22,0,0,1,98,312.4Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.81 268.97 92.09 268.97 92.74 260.67 103.16 260.67 103.81 268.97",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.51 272.92 73.22 281.2 67.81 274.88 75.18 267.51 81.51 272.92",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.53 291.48 68.53 303.2 60.23 302.55 60.23 292.13 68.53 291.48",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.47 313.78 80.76 322.07 74.44 327.48 67.07 320.11 72.47 313.78",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.04 326.76 102.76 326.76 102.11 335.06 91.69 335.06 91.04 326.76",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.34 322.81 121.63 314.53 127.03 320.85 119.67 328.22 113.34 322.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "126.32 304.25 126.32 292.53 134.62 293.18 134.62 303.6 126.32 304.25",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.37 281.95 114.09 273.66 120.41 268.25 127.78 275.62 122.37 281.95",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.61,234.66a30.47,30.47,0,1,0,30.47,30.47A30.47,30.47,0,0,0,606.61,234.66Zm0,44.7a14.23,14.23,0,1,1,14.23-14.23A14.23,14.23,0,0,1,606.61,279.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "612.47 235.92 600.75 235.92 601.4 227.63 611.82 227.63 612.47 235.92",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "590.17 239.87 581.88 248.16 576.47 241.83 583.84 234.47 590.17 239.87",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "577.19 258.43 577.19 270.15 568.89 269.5 568.89 259.08 577.19 258.43",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "581.13 280.74 589.42 289.02 583.1 294.43 575.73 287.06 581.13 280.74",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "599.7 293.72 611.41 293.72 610.77 302.01 600.35 302.01 599.7 293.72",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "622 289.77 630.29 281.48 635.69 287.81 628.32 295.18 622 289.77",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "634.98 271.21 634.98 259.49 643.27 260.14 643.27 270.56 634.98 271.21",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "631.03 248.9 622.75 240.62 629.07 235.21 636.44 242.58 631.03 248.9",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.37,294.22l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.06h-.44v-.45L665.39,283v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28V283c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.18,0,4.36,0,6.55.05L679,294Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.6,308.33l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.06h-.44v-.45l0-11.19v-.5h.5l13.24.07c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.83.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.18,0,4.36,0,6.55.05l6.57.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M707.14,308.33l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.07c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.14-5.65c0-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.19,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.79,161.07l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7,0h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.78-.14,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300,175.18l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.05h-.44v-.45L273,164v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28V164c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5L274,175.18l-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.56,175.18l-13.12.28-6.66.11c-2.23,0-4.46,0-6.7.05h-.44v-.45L302.58,164v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28V164c0,1.9-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.19,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.88,235.11l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.05H72v-.45l0-11.19v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.86,161.06l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.05h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41.05-8.82.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.84,52.38l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.06h-.44v-.45l0-11.19v-.5h.5l13.24.06c4.41,0,8.83.12,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41,0-8.83.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M705.61,66.49l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.05h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28v.27c0,1.9-.09,3.79-.14,5.65Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41,0-8.82.16-13.24.17l-13.24.06.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.34,52.39l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.06h-.45v-.45l0-11.19v-.5h.51l13.24.07c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.15-5.65c0-1.87-.11-3.71-.13-5.54l.28.27c-4.42.06-8.83.16-13.24.17l-13.24.06.5-.5L43.3,52.39,42.86,52c2.18,0,4.35,0,6.54,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M626.08,313.29c-6.39-13.13-17.57-19.88-30.17-16.15s-14.55,21.29-5.15,25.73,18.81-8.52,23.78-11.18S626.08,313.29,626.08,313.29Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.26,348.24c0-1.58-.09-3.16-.15-4.74l-.33-9.49c-.22-5.78-.84-11.45-3.24-16.78a26,26,0,0,0-10.13-11.68,21.28,21.28,0,0,0-5.33-2.3,12.46,12.46,0,0,0-6.22-3.41,25.35,25.35,0,0,0-8.86-.23c-.1,0-.1.18,0,.17a21.36,21.36,0,0,1,8.38.6,17.78,17.78,0,0,1,3.38,1.31,17,17,0,0,1,2,1.24,18,18,0,0,0-7.7.08,17,17,0,0,0-2.67.88,7.47,7.47,0,0,0-2.1-.18,12.57,12.57,0,0,0-2.73.39,20.94,20.94,0,0,0-5.18,2.26.08.08,0,1,0,.09.14,19.44,19.44,0,0,1,5.06-1.9,16.14,16.14,0,0,1,2.6-.38,11.53,11.53,0,0,1,1.44,0,16.66,16.66,0,0,0-8.14,8.12c0,.09.1.17.14.08a15.34,15.34,0,0,1,10.38-8.33c.28-.07.57-.1.85-.16a11.46,11.46,0,0,0-.14,1.27c-.08.64-.19,1.28-.32,1.91a30.9,30.9,0,0,1-2.55,7.57,17.52,17.52,0,0,1-2.13,3.59c-.08.1.07.21.13.1.76-1.18,1.64-2.28,2.33-3.51a26.45,26.45,0,0,0,1.71-3.66,24.87,24.87,0,0,0,1.12-3.94c.14-.71.25-1.42.33-2.14a4.72,4.72,0,0,0,.08-1.3,17.23,17.23,0,0,1,4.48-.09c-.56,3.13-1.16,6.4-2.92,9.12,0,.09.1.17.15.08a37.65,37.65,0,0,0,2.16-4.48,16.7,16.7,0,0,0,1.08-4.67,20.7,20.7,0,0,1,7.4,2.48,24.42,24.42,0,0,1,9.85,10.78,40.3,40.3,0,0,1,3.65,15.44c.42,6.71.51,13.46,1.18,20.16,0,.43.73.58.82.09A24.14,24.14,0,0,0,632.26,348.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.5,304.5a7.46,7.46,0,0,0-1.46-1.34,19.81,19.81,0,0,0-1.62-1.24,11.89,11.89,0,0,0-3.63-1.68c-.1,0-.14.14,0,.16a9.71,9.71,0,0,1,3.59,1.76c.53.39,1,.82,1.54,1.25a9.25,9.25,0,0,0,1.47,1.25C617.44,304.71,617.56,304.59,617.5,304.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.11,309.26a36.74,36.74,0,0,0-2.93,3.87,23.65,23.65,0,0,0-2.18,4.32c0,.05,0,.08.07,0a51.62,51.62,0,0,1,5.16-8.12C597.3,309.29,597.17,309.17,597.11,309.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.85,308a9.28,9.28,0,0,1-.72,2.37,15.23,15.23,0,0,1-1.22,2.11s0,.09.08.05a8.51,8.51,0,0,0,2-4.49C611,307.89,610.87,307.85,610.85,308Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M631.37,313.61s9-11.37,26.51-7.34c16.59,3.83,24.25,34.26,7.48,37.9s-13.81-24.52-19.92-29.29C641,311.37,634.5,312.12,631.37,313.61Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.36,322.89a34.66,34.66,0,0,0-3.6-2.76,15.59,15.59,0,0,0-3.83-1.91,23,23,0,0,0-2.28-2.93,22.77,22.77,0,0,0-5.27-4.2c.17,0,.34,0,.52,0a25.62,25.62,0,0,1,2.77,0,15.65,15.65,0,0,1,5.39,1.34.08.08,0,1,0,.07-.15,24.71,24.71,0,0,0-5.38-1.62,15.56,15.56,0,0,0-2.73-.23c-.49,0-1,0-1.46.08l-.28,0a23.63,23.63,0,0,0-5-1.86l.49-.13a25,25,0,0,1,2.59-.42,19.83,19.83,0,0,1,5.22.08.09.09,0,0,0,0-.17,33.23,33.23,0,0,0-5.28-.21,22.67,22.67,0,0,0-4.39.57,22.59,22.59,0,0,0-3.18-.36c-6.09-.26-12.73,2-16.48,7s-4.48,11.69-5.14,17.73a135.41,135.41,0,0,0-.67,25.38c0,.5.74.41.76-.07.23-7.17.48-14.35,1.17-21.5.31-3.31.67-6.63,1.22-9.92a29.36,29.36,0,0,1,2.4-8.16,15,15,0,0,1,5.9-6.34,19.8,19.8,0,0,1,8.34-2.56,22.49,22.49,0,0,1,7.84.73,5.3,5.3,0,0,0,0,1.54,8.87,8.87,0,0,0,.39,1.91,9.08,9.08,0,0,0,.73,1.7c.32.6.73,1.13,1.09,1.7,0,.1.2,0,.13-.09a7.92,7.92,0,0,1-1.35-3.44,13.49,13.49,0,0,1-.21-1.78c0-.45,0-.91,0-1.35a22.93,22.93,0,0,1,7.63,4c.42.34.83.7,1.23,1.07a8.44,8.44,0,0,0-1.48,1.82,18.23,18.23,0,0,0-1.55,2.76,23.65,23.65,0,0,0-1.62,6.08c0,.1.15.13.17,0a17.59,17.59,0,0,1,2-5.76,25.62,25.62,0,0,1,1.55-2.56c.3-.42.6-.83.92-1.23.17-.22.36-.44.52-.67a24,24,0,0,1,5,7l0,0a11.84,11.84,0,0,0-2,2.94,25.78,25.78,0,0,0-1.63,3.49,58.66,58.66,0,0,0-2.09,7.12c0,.1.15.13.17,0a30,30,0,0,1,2.47-7c.53-1.1,1.08-2.17,1.66-3.24a31.93,31.93,0,0,0,1.64-3.05,22.48,22.48,0,0,1,2,8.09c0,.1.17.09.17,0A28.23,28.23,0,0,0,664.46,319c1.06.46,2.14.89,3.16,1.45a17.33,17.33,0,0,1,3.63,2.55C671.33,323.09,671.44,323,671.36,322.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.56,323.54c-.53,1.72-1.19,3.39-1.66,5.13a19.92,19.92,0,0,0-.77,5.14s.08.05.08,0a49.86,49.86,0,0,1,2.5-10.22A.08.08,0,1,0,658.56,323.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.62,319.26a9.7,9.7,0,0,0-2.32-1.65,17,17,0,0,0-2.67-.95c-.1,0-.14.14,0,.16a10.51,10.51,0,0,1,2.57,1.07,18.67,18.67,0,0,1,2.38,1.45A.05.05,0,0,0,669.62,319.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640,298.43s1.67-20.43,16.85-27.05c12.68-5.53,19.94,8.72,11,17.44C660.55,295.88,648.92,292.7,640,298.43Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665,275.34a62.13,62.13,0,0,0-6.75,3.2A49.72,49.72,0,0,0,653,282c.26-.52.47-1.06.73-1.57a26,26,0,0,1,1.29-2.3,21.75,21.75,0,0,1,3.34-4.24c.08-.07,0-.19-.12-.11a32.81,32.81,0,0,0-3.52,4.1,22.87,22.87,0,0,0-1.44,2.31,8.77,8.77,0,0,0-1,2.35l-.17.12a49.65,49.65,0,0,0-7.25,7.1c0-.2.08-.4.13-.59.29-1,.6-2,.92-3a25.11,25.11,0,0,1,2.75-6c.06-.09-.09-.18-.15-.08a48,48,0,0,0-3.18,5.8,23.47,23.47,0,0,0-1,3,13.8,13.8,0,0,0-.49,2.06c-.66.83-1.31,1.68-1.92,2.55-6.52,9.28-9.8,20.51-10.58,31.74a99.28,99.28,0,0,0-.17,10.06,63.29,63.29,0,0,0,.89,10.1c0,.21.37.15.37-.06-.08-2.95-.38-5.89-.44-8.84s.05-5.92.28-8.87a82.23,82.23,0,0,1,3.32-17.38A62.24,62.24,0,0,1,643.23,294c.64-.13,1.27-.3,1.9-.46s1.52-.39,2.27-.6a22.94,22.94,0,0,0,4.24-1.56c.09,0,0-.19-.09-.14a13.39,13.39,0,0,1-4.3,1.48c-1.18.24-2.42.4-3.61.67a57.23,57.23,0,0,1,3.53-4.64,26.43,26.43,0,0,0,8.64-.65,34.22,34.22,0,0,0,4.42-1.37c1.52-.59,3-1.34,4.46-2,.12-.05,0-.21-.06-.15a25.73,25.73,0,0,1-8.76,2.87,53.64,53.64,0,0,1-8.19.67c1.08-1.24,2.19-2.44,3.38-3.57,4-3.8,8.73-7.29,14-9.11C665.14,275.46,665.09,275.3,665,275.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.63,275.4a22.92,22.92,0,0,0-1.86,2.72,15.23,15.23,0,0,0-1.34,3.17s.05.06.06,0c.51-1,.94-2.05,1.45-3a14.93,14.93,0,0,1,1.81-2.76C652.82,275.43,652.7,275.32,652.63,275.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.75,282.2a15.72,15.72,0,0,1-3.11,1.3,27,27,0,0,1-3.17.85c-.05,0,0,.1,0,.09a15.25,15.25,0,0,0,3.28-.72,26.55,26.55,0,0,0,3.08-1.38C666.93,282.3,666.85,282.15,666.75,282.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.16,294.75c-.09.88-2.29-7.41-15.13-14.78-11.66-6.69-25.58-24.09-14.15-35.08C608.11,236,632.42,255.36,628.16,294.75Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M637,342.32a225.33,225.33,0,0,0-2-25.81,116,116,0,0,0-5.42-23.11c-1-2.7-2-5.35-3.23-8a19.34,19.34,0,0,0,0-3.05c-.07-1.31-.18-2.62-.31-3.92s-.25-2.61-.4-3.91-.43-2.59-.49-3.89a.08.08,0,1,0-.16,0,28.81,28.81,0,0,1,.46,4.14q.15,1.89.21,3.78c0,1.26,0,2.53,0,3.79,0,.46,0,.94,0,1.43-1.21-2.55-2.5-5.07-3.9-7.51.87-5.33-.26-10.89-1.35-16.09,0-.11-.18-.06-.16,0a44.93,44.93,0,0,1,.85,8.25c0,2.19,0,4.38-.06,6.56-.31-.52-.62-1.05-.93-1.56-1.67-2.72-3.45-5.39-5.34-8a12.35,12.35,0,0,0-.12-3.79,30.75,30.75,0,0,0-.93-4.15c-.41-1.36-.88-2.7-1.42-4s-1.3-2.63-1.84-4a.08.08,0,1,0-.15.07,19.19,19.19,0,0,1,1.61,4,36.75,36.75,0,0,1,1,4c.27,1.35.49,2.7.68,4.07.13.9.21,1.84.36,2.75a98.54,98.54,0,0,0-9-10.46c-.07-.08-.18,0-.11.12a118.78,118.78,0,0,1,13.05,17.76l.42.71c-.71-.44-1.52-.79-2.19-1.16l-3.74-2.06c-1.22-.65-2.43-1.32-3.64-2-.62-.34-1.24-.7-1.87-1a14.89,14.89,0,0,1-2.18-1.2.08.08,0,1,0-.09.13c1.23.68,2.32,1.69,3.52,2.45s2.42,1.5,3.66,2.2c2.29,1.27,4.76,2.19,7,3.51,1.56,2.72,3,5.52,4.32,8.37q-2-1.31-4.17-2.49c-.91-.51-1.82-1-2.74-1.5a13.3,13.3,0,0,1-2.59-1.56.08.08,0,1,0-.11.12,24.16,24.16,0,0,0,4.93,3.43c1.65,1,3.31,1.89,5,2.74,1.37,3,2.62,6.07,3.71,9.18,5.41,15.31,7.39,31.55,8.34,47.68.29,4.81.43,9.62.49,14.44s-.19,9.61-.18,14.42c0,.14.23.17.25,0,.58-4.27.68-8.61.87-12.9S637.1,346.7,637,342.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.68,273.05a61.27,61.27,0,0,1-6.83-3.53,73,73,0,0,1-6.48-4.11s-.07,0,0,.06a54.58,54.58,0,0,0,6.22,4.35,63.19,63.19,0,0,0,7,3.38C613.69,273.24,613.77,273.09,613.68,273.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.39,255.75c-.19-.74-.42-1.48-.67-2.2a.07.07,0,0,0,0-.09c-.16-.41-.33-.82-.5-1.23a1.16,1.16,0,0,0-.06-.15l-.1-.24s-.05,0,0,0,.08.29.13.43a1.27,1.27,0,0,0,.07.24,61.76,61.76,0,0,1,1.9,8.71.08.08,0,1,0,.15,0A29.17,29.17,0,0,0,617.39,255.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "650.57 345.43 649.65 356.29 646.85 389.4 616.8 389.4 614 356.29 613.09 345.43 650.57 345.43",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "650.57 345.43 649.65 356.29 614 356.29 613.09 345.43 650.57 345.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.14,
    y: 341.07,
    width: 43.38,
    height: 10.42,
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50.72 389.4 131.79 389.16 212.86 389.07 375 388.91 537.14 389.07 618.21 389.16 699.28 389.4 618.21 389.65 537.14 389.74 375 389.9 212.86 389.74 131.79 389.65 50.72 389.4",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-17"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: 451.23,
    rx: 294.01,
    ry: 23.31,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-17"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.33,
    y: 125.72,
    width: 421.66,
    height: 282.06,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.39,
    y: 129.16,
    width: 415.53,
    height: 275.18,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.41,
    y: 428.94,
    width: 531.5,
    height: 19.36,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.41 428.94 163.33 407.79 584.99 407.79 639.91 428.94 108.41 428.94",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.23 421.43 203.67 407.79 544.65 407.79 580.09 421.43 168.23 421.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.88,
    y: 150.07,
    width: 368.57,
    height: 233.37,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.56,
    y: 159.05,
    width: 362.34,
    height: 56.41,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.56,
    y: 150.07,
    width: 368.88,
    height: 8.98,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.7,154.56a2.23,2.23,0,1,1-2.23-2.23A2.23,2.23,0,0,1,196.7,154.56Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.8,154.56a2.23,2.23,0,1,1-2.23-2.23A2.23,2.23,0,0,1,205.8,154.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.89,154.56a2.23,2.23,0,1,1-2.23-2.23A2.23,2.23,0,0,1,214.89,154.56Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 551.9,
    y: 159.05,
    width: 6.54,
    height: 224.39,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.17,236.84h0a1.68,1.68,0,0,1-1.69-1.69V162.06a1.68,1.68,0,0,1,1.69-1.69h0a1.69,1.69,0,0,1,1.69,1.69v73.09A1.69,1.69,0,0,1,555.17,236.84Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.92,
    y: 170,
    width: 88.09,
    height: 11.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.14,181.88H444.8v-12h88.34Zm-88.1-.24H532.9V170.12H445Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521.14,
    y: 169.88,
    width: 12,
    height: 12,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.86,179.17l-1.08.83-2-2.66-.74-1a1.76,1.76,0,0,0,.42-.24,1.83,1.83,0,0,0,.56-.72l.78,1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.73,172.92a3,3,0,1,0-1,4.42,2.63,2.63,0,0,0,.41-.27,3,3,0,0,0,.61-.63A3,3,0,0,0,528.73,172.92Zm-1.28,3.21a1.77,1.77,0,0,1-2.16-2.81,1.77,1.77,0,0,1,2.72,2.09A1.83,1.83,0,0,1,527.45,176.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.38,
    y: 172.31,
    width: 0.63,
    height: 7.14,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.62,
    y: 170,
    width: 202.88,
    height: 11.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.63,181.88H237.5v-12H440.63Zm-202.89-.24H440.39V170.12H237.74Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.08,
    y: 172.31,
    width: 0.63,
    height: 7.14,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.43 179.9 211.15 175.96 215.42 171.86 216.09 172.55 212.55 175.95 216.08 179.2 215.43 179.9",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.77 171.85 230.05 175.8 225.77 179.9 225.11 179.2 228.65 175.81 225.12 172.56 225.77 171.85",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.59,
    y: 312.51,
    width: 65.77,
    height: 50.46,
    transform: "translate(790.96 675.47) rotate(180)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.14,323.54a6,6,0,1,0,4.69-4.69A6,6,0,0,0,369.14,323.54Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.29 352.1 428.37 352.1 406.33 324.94 384.29 352.1",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.29 352.1 428.37 352.1 406.33 324.94 384.29 352.1",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.6 352.12 401.68 352.12 382.14 334.44 362.6 352.12",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.6 352.12 401.68 352.12 382.14 334.44 362.6 352.12",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.59,
    y: 352.1,
    width: 65.77,
    height: 10.87,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.59,
    y: 352.1,
    width: 65.77,
    height: 10.87,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.8,
    y: 312.51,
    width: 49.4,
    height: 4.16,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.8,
    y: 322.15,
    width: 142.97,
    height: 4.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.8,
    y: 331.29,
    width: 142.97,
    height: 4.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.8,
    y: 340.44,
    width: 142.97,
    height: 4.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.8,
    y: 349.58,
    width: 142.97,
    height: 4.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.8,
    y: 358.73,
    width: 142.97,
    height: 4.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.87,
    y: 230.91,
    width: 49.4,
    height: 11.12,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.87,
    y: 249.7,
    width: 101.5,
    height: 4.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.87,
    y: 258.84,
    width: 101.5,
    height: 4.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.87,
    y: 267.99,
    width: 101.5,
    height: 4.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.87,
    y: 277.13,
    width: 101.5,
    height: 4.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.87,
    y: 289.3,
    width: 101.5,
    height: 4.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.87,
    y: 298.44,
    width: 101.5,
    height: 4.16,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.78,
    y: 230.91,
    width: 90.34,
    height: 11.32,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 443.03,
    y: 242.23,
    width: 89.86,
    height: 120.54,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.14,363H442.78V242h90.36Zm-89.86-.4h89.36V242.43H443.28Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.26 362.84 442.79 362.69 532.66 242.16 533.12 242.3 443.26 362.84",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "532.66 362.84 442.79 242.3 443.26 242.16 533.12 362.69 532.66 362.84",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.99,
    y: 231.11,
    width: 107.67,
    height: 71.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.82,302.6v-.18l0-71.48H208l107.85,0,0,71.66h-.18Zm.34-71.3,0,70.94,107.31,0,0-70.94Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.16,231.3c9.06,5.74,18.06,11.57,27.05,17.41l26.89,17.63,26.77,17.82,13.34,9,13.28,9.07-13.55-8.66-13.49-8.75-26.9-17.63-26.77-17.82C225.88,243.37,217,237.38,208.16,231.3Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.49,231.3c-8.83,6.08-17.72,12.07-26.62,18L262.1,267.17,235.21,284.8l-13.5,8.75-13.55,8.66,13.28-9.07,13.34-9,26.77-17.82,26.9-17.63C297.44,242.87,306.43,237,315.49,231.3Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.85,179a10.09,10.09,0,1,0-9.11-11A10.09,10.09,0,0,0,421.85,179ZM414,168.12a8.86,8.86,0,1,1,8,9.64A8.86,8.86,0,0,1,414,168.12ZM421.85,179a10.09,10.09,0,1,0-9.11-11A10.09,10.09,0,0,0,421.85,179ZM414,168.12a8.86,8.86,0,1,1,8,9.64A8.86,8.86,0,0,1,414,168.12ZM421.85,179a10.09,10.09,0,1,0-9.11-11A10.09,10.09,0,0,0,421.85,179ZM414,168.12a8.86,8.86,0,1,1,8,9.64A8.86,8.86,0,0,1,414,168.12Zm6.85,22A21.28,21.28,0,1,0,401.6,167,21.28,21.28,0,0,0,420.81,190.12Zm-9.64-22.26a11.66,11.66,0,1,1,10.53,12.69A11.68,11.68,0,0,1,411.17,167.86Zm1.57.14a10.09,10.09,0,1,0,11-9.11A10.09,10.09,0,0,0,412.74,168Zm1.22.12a8.86,8.86,0,1,1,8,9.64A8.86,8.86,0,0,1,414,168.12ZM421.85,179a10.09,10.09,0,1,0-9.11-11A10.09,10.09,0,0,0,421.85,179ZM414,168.12a8.86,8.86,0,1,1,8,9.64A8.86,8.86,0,0,1,414,168.12ZM421.85,179a10.09,10.09,0,1,0-9.11-11A10.09,10.09,0,0,0,421.85,179ZM414,168.12a8.86,8.86,0,1,1,8,9.64A8.86,8.86,0,0,1,414,168.12Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "420.6 148.25 428.74 149.01 428.83 143.21 421.58 142.53 420.6 148.25",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "435.85 152.44 441.07 158.73 445.24 154.69 440.59 149.09 435.85 152.44",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.67 166.18 442.91 174.33 448.72 174.41 449.39 167.17 443.67 166.18",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.48 181.43 433.19 186.65 437.23 190.82 442.83 186.17 439.48 181.43",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.74 189.25 417.6 188.49 417.51 194.3 424.76 194.97 425.74 189.25",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.49 185.07 405.27 178.77 401.1 182.82 405.75 188.42 410.49 185.07",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "402.67 171.33 403.43 163.18 397.62 163.09 396.95 170.34 402.67 171.33",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.86 156.08 413.15 150.85 409.11 146.69 403.51 151.33 406.86 156.08",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.85,179a10.09,10.09,0,1,0-9.11-11A10.09,10.09,0,0,0,421.85,179ZM414,168.12a8.86,8.86,0,1,1,8,9.64A8.86,8.86,0,0,1,414,168.12ZM421.85,179a10.09,10.09,0,1,0-9.11-11A10.09,10.09,0,0,0,421.85,179ZM414,168.12a8.86,8.86,0,1,1,8,9.64A8.86,8.86,0,0,1,414,168.12ZM421.85,179a10.09,10.09,0,1,0-9.11-11A10.09,10.09,0,0,0,421.85,179ZM414,168.12a8.86,8.86,0,1,1,8,9.64A8.86,8.86,0,0,1,414,168.12Zm6.85,22A21.28,21.28,0,1,0,401.6,167,21.28,21.28,0,0,0,420.81,190.12Zm-9.64-22.26a11.66,11.66,0,1,1,10.53,12.69A11.68,11.68,0,0,1,411.17,167.86Zm1.57.14a10.09,10.09,0,1,0,11-9.11A10.09,10.09,0,0,0,412.74,168Zm1.22.12a8.86,8.86,0,1,1,8,9.64A8.86,8.86,0,0,1,414,168.12ZM421.85,179a10.09,10.09,0,1,0-9.11-11A10.09,10.09,0,0,0,421.85,179ZM414,168.12a8.86,8.86,0,1,1,8,9.64A8.86,8.86,0,0,1,414,168.12ZM421.85,179a10.09,10.09,0,1,0-9.11-11A10.09,10.09,0,0,0,421.85,179ZM414,168.12a8.86,8.86,0,1,1,8,9.64A8.86,8.86,0,0,1,414,168.12Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "420.6 148.25 428.74 149.01 428.83 143.21 421.58 142.53 420.6 148.25"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "435.85 152.44 441.07 158.73 445.24 154.69 440.59 149.09 435.85 152.44"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "443.67 166.18 442.91 174.33 448.72 174.41 449.39 167.17 443.67 166.18"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "439.48 181.43 433.19 186.65 437.23 190.82 442.83 186.17 439.48 181.43"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "425.74 189.25 417.6 188.49 417.51 194.3 424.76 194.97 425.74 189.25"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "410.49 185.07 405.27 178.77 401.1 182.82 405.75 188.42 410.49 185.07"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "402.67 171.33 403.43 163.18 397.62 163.09 396.95 170.34 402.67 171.33"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "406.86 156.08 413.15 150.85 409.11 146.69 403.51 151.33 406.86 156.08"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M519.63,197.69a6.47,6.47,0,1,0-5.84-7A6.47,6.47,0,0,0,519.63,197.69Zm-5-7a5.68,5.68,0,1,1,5.13,6.19A5.68,5.68,0,0,1,514.58,190.72Zm5,7a6.47,6.47,0,1,0-5.84-7A6.47,6.47,0,0,0,519.63,197.69Zm-5-7a5.68,5.68,0,1,1,5.13,6.19A5.68,5.68,0,0,1,514.58,190.72Zm5,7a6.47,6.47,0,1,0-5.84-7A6.47,6.47,0,0,0,519.63,197.69Zm-5-7a5.68,5.68,0,1,1,5.13,6.19A5.68,5.68,0,0,1,514.58,190.72ZM519,204.83A13.64,13.64,0,1,0,506.66,190,13.63,13.63,0,0,0,519,204.83Zm-6.18-14.27a7.48,7.48,0,1,1,6.75,8.13A7.48,7.48,0,0,1,512.79,190.56Zm1,.09a6.47,6.47,0,1,0,7-5.84A6.47,6.47,0,0,0,513.79,190.65Zm.79.07a5.68,5.68,0,1,1,5.13,6.19A5.68,5.68,0,0,1,514.58,190.72Zm5,7a6.47,6.47,0,1,0-5.84-7A6.47,6.47,0,0,0,519.63,197.69Zm-5-7a5.68,5.68,0,1,1,5.13,6.19A5.68,5.68,0,0,1,514.58,190.72Zm5,7a6.47,6.47,0,1,0-5.84-7A6.47,6.47,0,0,0,519.63,197.69Zm-5-7a5.68,5.68,0,1,1,5.13,6.19A5.68,5.68,0,0,1,514.58,190.72Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "518.83 177.99 524.05 178.47 524.11 174.75 519.47 174.32 518.83 177.99",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "528.61 180.67 531.96 184.71 534.63 182.11 531.65 178.53 528.61 180.67",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "533.62 189.48 533.14 194.7 536.86 194.76 537.29 190.11 533.62 189.48",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "530.94 199.26 526.9 202.61 529.5 205.28 533.09 202.3 530.94 199.26",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "522.13 204.27 516.91 203.79 516.86 207.51 521.5 207.94 522.13 204.27",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512.36 201.59 509.01 197.55 506.34 200.15 509.31 203.74 512.36 201.59",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "507.34 192.78 507.83 187.56 504.1 187.5 503.67 192.15 507.34 192.78",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "510.02 183 514.06 179.66 511.47 176.99 507.88 179.96 510.02 183",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M519.63,197.69a6.47,6.47,0,1,0-5.84-7A6.47,6.47,0,0,0,519.63,197.69Zm-5-7a5.68,5.68,0,1,1,5.13,6.19A5.68,5.68,0,0,1,514.58,190.72Zm5,7a6.47,6.47,0,1,0-5.84-7A6.47,6.47,0,0,0,519.63,197.69Zm-5-7a5.68,5.68,0,1,1,5.13,6.19A5.68,5.68,0,0,1,514.58,190.72Zm5,7a6.47,6.47,0,1,0-5.84-7A6.47,6.47,0,0,0,519.63,197.69Zm-5-7a5.68,5.68,0,1,1,5.13,6.19A5.68,5.68,0,0,1,514.58,190.72ZM519,204.83A13.64,13.64,0,1,0,506.66,190,13.63,13.63,0,0,0,519,204.83Zm-6.18-14.27a7.48,7.48,0,1,1,6.75,8.13A7.48,7.48,0,0,1,512.79,190.56Zm1,.09a6.47,6.47,0,1,0,7-5.84A6.47,6.47,0,0,0,513.79,190.65Zm.79.07a5.68,5.68,0,1,1,5.13,6.19A5.68,5.68,0,0,1,514.58,190.72Zm5,7a6.47,6.47,0,1,0-5.84-7A6.47,6.47,0,0,0,519.63,197.69Zm-5-7a5.68,5.68,0,1,1,5.13,6.19A5.68,5.68,0,0,1,514.58,190.72Zm5,7a6.47,6.47,0,1,0-5.84-7A6.47,6.47,0,0,0,519.63,197.69Zm-5-7a5.68,5.68,0,1,1,5.13,6.19A5.68,5.68,0,0,1,514.58,190.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "518.83 177.99 524.05 178.47 524.11 174.75 519.47 174.32 518.83 177.99",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "528.61 180.67 531.96 184.71 534.63 182.11 531.65 178.53 528.61 180.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "533.62 189.48 533.14 194.7 536.86 194.76 537.29 190.11 533.62 189.48",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "530.94 199.26 526.9 202.61 529.5 205.28 533.09 202.3 530.94 199.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "522.13 204.27 516.91 203.79 516.86 207.51 521.5 207.94 522.13 204.27",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512.36 201.59 509.01 197.55 506.34 200.15 509.31 203.74 512.36 201.59",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "507.34 192.78 507.83 187.56 504.1 187.5 503.67 192.15 507.34 192.78",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "510.02 183 514.06 179.66 511.47 176.99 507.88 179.96 510.02 183",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M443.66,199.86A26.64,26.64,0,1,0,471,173.92,26.64,26.64,0,0,0,443.66,199.86Zm14.19.38A12.44,12.44,0,1,1,470,213,12.45,12.45,0,0,1,457.85,200.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "465.85 174.9 476.09 175.16 475.71 167.9 466.61 167.66 465.85 174.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "485.25 178.86 492.31 186.29 497.18 180.89 490.9 174.28 485.25 178.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "496.17 195.39 495.9 205.63 503.17 205.25 503.41 196.15 496.17 195.39",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "492.2 214.79 484.77 221.84 490.17 226.72 496.79 220.44 492.2 214.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.68 225.71 465.44 225.44 465.81 232.71 474.92 232.95 475.68 225.71",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "456.27 221.74 449.22 214.31 444.35 219.71 450.62 226.32 456.27 221.74",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.36 205.22 445.63 194.97 438.36 195.35 438.12 204.46 445.36 205.22",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "449.32 185.81 456.75 178.76 451.35 173.89 444.74 180.16 449.32 185.81",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.37,194l-8.73-2.59L462,197.72l2.13,8.85,8.72,2.59,6.62-6.27Zm-6.68,9.16a2.89,2.89,0,1,1,3-2.81A2.88,2.88,0,0,1,470.69,203.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.55,98.26c-5,5.88-13.57,8.07-21.08,8.45s-16.24-.41-23.13-4a18.43,18.43,0,0,1-7.51-6.67c-1.87-3.09-2.06-6.33,0-9.19,1.67-2.3,5.29-3.92,5.32-6S456.43,77,456,75c-.79-3.51,1.17-6.1,3.69-8.34,6-5.32,4.43-12.45,8.13-19.1,2.11-3.79,8-10.74,18.43-7.4,4,1.26,6.63,4.84,8.21,8.54,1.86,4.34.44,10,2.72,14.18,1.95,3.56,4.86,4.17,6.71,7.91.81,1.62,1.18,3.5-.61,7.28-.65,1.37-1.34,3.45-.78,5.1.79,2.27,3.51,3.35,4.38,5.72C508,92.11,506.74,95.66,504.55,98.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.15,97c-3.58-.62-5.06-5.5-2.76-7.94,1.46-1.56,3.63-2.25,5.09-3.8,2.4-2.54.31-4.9-.94-7.44-2.71-5.52,1.13-9.17,5.18-12.5,3.07-2.53,3.72-5.47,4-9.25a.06.06,0,0,0-.11,0c-.31,2.78-.74,5.52-2.75,7.67-1.64,1.75-3.8,2.93-5.38,4.75a8.29,8.29,0,0,0-1.22,9.94c.52,1,1.51,2.19,1.71,3.29.47,2.62-1.54,3.93-3.45,5.19-1.47,1-3.09,2-3.66,3.76-.86,2.62,1.49,6.23,4.27,6.55C455.24,97.24,455.29,97,455.15,97Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.06,99.7c-2.18-1.34-4.55-2.56-5.81-4.87-1.87-3.41.56-5.92,2.82-8.28a4.83,4.83,0,0,0,1.76-3.48c0-2.17-1.63-4-1.87-6.18-.56-5.15,4.65-8.17,7.31-11.9s3.64-8.29,4.67-12.73a.08.08,0,0,0-.15,0c-1.36,5.66-3.14,11-7.3,15.29-2.9,3-6,6.27-4.73,10.71.31,1.1.95,2.1,1.23,3.19.57,2.16-.05,3.55-1.52,5.07s-3.05,3-3.35,5.05c-.57,4.08,3.54,6.85,6.77,8.48A.18.18,0,0,0,457.06,99.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.82,87.58c-1.73-2.52-4.53-3.82-3.7-7.35.56-2.43,2-4.35,1.52-7A9.37,9.37,0,0,0,502.31,68c-2.06-1.84-4.34-3.35-5.8-5.72-1.61-2.58-2.28-5.59-3-8.48,0-.06-.11,0-.1,0,.71,3.93,1.61,8,4.55,11,1.54,1.57,3.43,2.77,4.95,4.36,2.74,2.85,2.63,5.89,1.33,9.33-.6,1.58-1.14,3.16-.44,4.81s2.25,2.69,3.32,4.07c4.51,5.9-2.86,13-8.82,13.91-.27,0-.25.44,0,.41,4.45-.54,9.25-4.35,10.36-8.61A6.7,6.7,0,0,0,507.82,87.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.53,90.66c0-2.59-1.57-4.06-2.78-6.13-1.91-3.24.25-6.32.6-9.68a8.2,8.2,0,0,0-2.1-6.11c-1.92-2.36-4.41-4.08-6-6.77a16.37,16.37,0,0,1-2.09-9.44c0-.06-.09-.05-.1,0A15.71,15.71,0,0,0,499,64.89c1.93,2.15,4.57,3.93,5.6,6.78,1.09,3-.52,5.68-1,8.63a6.45,6.45,0,0,0,1.13,5,13.45,13.45,0,0,1,2.13,3.52,7.83,7.83,0,0,1-.72,5.52c-2.55,5.36-8.48,8.58-14.06,9.29-.19,0-.19.34,0,.32A19.42,19.42,0,0,0,505,96.91,10.6,10.6,0,0,0,507.53,90.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.74,74.66c-14,14.72-31.51,45.49-28.05,51.61,3.84,6.82,24.1-14.14,23.46-15.14-.54-.85,6.46-19.38,11.55-32.93S482.22,71,478.74,74.66Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.53,92.31l20.17,3.63s5-14.29,6-22.22c.56-4.45-2.06-4.63-5.35-2.27C470.89,79.72,461.53,92.31,461.53,92.31Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.08,81.41a7,7,0,0,0-.64,1.91,6.75,6.75,0,0,0-.12,2,7,7,0,0,0,.63-1.91A7.1,7.1,0,0,0,475.08,81.41Zm-10.51,8.45a8.28,8.28,0,0,0-1-.13,3.92,3.92,0,0,0-.27.33,9.15,9.15,0,0,0,1.17.31,7.07,7.07,0,0,0,2,.13A7.17,7.17,0,0,0,464.57,89.86ZM485.88,79a7.34,7.34,0,0,0-1.34-1.51,7.46,7.46,0,0,0,.9,1.81,9.53,9.53,0,0,0,1,1.16c0-.13.07-.26.1-.38h0A10.28,10.28,0,0,0,485.88,79Zm-8.31,14a7.28,7.28,0,0,0-1.51,1.33,7.82,7.82,0,0,0,3.32-2.24A7.15,7.15,0,0,0,477.57,93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.57,92.64a134.51,134.51,0,0,0-17-3.36s-.06.12,0,.13c4.59,1.18,13.88,2.87,17,3.42C481.59,92.84,481.63,92.66,481.57,92.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.74,73.72c-1,7.93-6,22.22-6,22.22l-15.45-2.78L486.05,70C487.34,70,488.06,71.18,487.74,73.72Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.55,125.67h51.12s-6-35-22.49-53.77a10.4,10.4,0,0,0-14.94-.78c-.95.85-11.66,15-13.35,22.23-1.11,4.73,3.35,9.94,3.35,9.94Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.31,82.25a6.82,6.82,0,0,0-1.51,1.34,7.25,7.25,0,0,0,1.8-.91,6.81,6.81,0,0,0,1.51-1.33A6.9,6.9,0,0,0,498.31,82.25ZM510.54,122a7.09,7.09,0,0,0-1.51,1.34,6.92,6.92,0,0,0,1.8-.91,7.09,7.09,0,0,0,1.52-1.33A7.12,7.12,0,0,0,510.54,122Zm-17.16-14.39a7.09,7.09,0,0,0-1.52,1.33,7.66,7.66,0,0,0,3.32-2.24A6.92,6.92,0,0,0,493.38,107.56Zm-19.57,13.75a7.05,7.05,0,0,0-1.51,1.34,7.15,7.15,0,0,0,1.81-.91,7.28,7.28,0,0,0,1.51-1.33A6.81,6.81,0,0,0,473.81,121.31ZM477.57,93a7.28,7.28,0,0,0-1.51,1.33,7.82,7.82,0,0,0,3.32-2.24A7.15,7.15,0,0,0,477.57,93Zm22.85,4.65a7,7,0,0,0-1.33-1.51,7.22,7.22,0,0,0,.9,1.8,6.61,6.61,0,0,0,1.34,1.51A7.25,7.25,0,0,0,500.42,97.64Zm18,16.4a6.87,6.87,0,0,0-1.34-1.52,7.15,7.15,0,0,0,.91,1.81,7,7,0,0,0,1.33,1.51A6.6,6.6,0,0,0,518.38,114Zm-32.85,3.55a6.82,6.82,0,0,0-1.34-1.51,7.25,7.25,0,0,0,.91,1.8,7,7,0,0,0,1.33,1.51A6.9,6.9,0,0,0,485.53,117.59ZM485.88,79a7.34,7.34,0,0,0-1.34-1.51,7.46,7.46,0,0,0,.9,1.81,7.64,7.64,0,0,0,1.34,1.51A7.12,7.12,0,0,0,485.88,79Zm6.2-28.68a7.07,7.07,0,0,0-2-.13,6.72,6.72,0,0,0,1.91.64,7.14,7.14,0,0,0,2,.13A7.23,7.23,0,0,0,492.08,50.28ZM502,114.37a7.07,7.07,0,0,0-2-.13,7.17,7.17,0,0,0,1.91.64,6.81,6.81,0,0,0,2,.12A7.09,7.09,0,0,0,502,114.37Zm-16.68-13.24a7.14,7.14,0,0,0-2-.12,7.23,7.23,0,0,0,1.92.64,7.48,7.48,0,0,0,2,.12A7,7,0,0,0,485.28,101.13Zm23.86-9.74a7.46,7.46,0,0,0-2-.12,7.11,7.11,0,0,0,1.92.64,7.46,7.46,0,0,0,2,.12A7.11,7.11,0,0,0,509.14,91.39Zm-13.75-20a7.14,7.14,0,0,0-2-.13,7.11,7.11,0,0,0,1.92.64,6.73,6.73,0,0,0,2,.12A7.14,7.14,0,0,0,495.39,71.42Zm15.37,32.18a7.11,7.11,0,0,0-.64,1.92,7.46,7.46,0,0,0-.12,2,7,7,0,0,0,.64-1.91A7.53,7.53,0,0,0,510.76,103.6Zm-32.56,2.62a7.2,7.2,0,0,0-.63,1.92,7.1,7.1,0,0,0-.13,2,7,7,0,0,0,.64-1.91A7.14,7.14,0,0,0,478.2,106.22Zm19.93,14.54a7,7,0,0,0-.63,1.91,7.14,7.14,0,0,0-.13,2,7.23,7.23,0,0,0,.64-1.92A7.09,7.09,0,0,0,498.13,120.76ZM490,88.56a7.11,7.11,0,0,0-.64,1.92,7.46,7.46,0,0,0-.12,2,7.11,7.11,0,0,0,.64-1.92A7.46,7.46,0,0,0,490,88.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.17,101.87a44.15,44.15,0,0,1,6.35,1.1c1,.28,2.05.6,3.06.94.5.17,1,.32,1.52.48a7.11,7.11,0,0,0,1.64.32c.05,0,.05.07,0,.08a11.86,11.86,0,0,1-1.58-.05,12.42,12.42,0,0,1-1.5-.29c-1.05-.27-2.09-.59-3.14-.87-2.11-.56-4.23-1.12-6.38-1.53C483,102,483.07,101.86,483.17,101.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.86,103.72a49.62,49.62,0,0,1,5.31-.21c.89,0,1.77.09,2.65.18l1.27.16c.46.06.91.19,1.38.24a0,0,0,0,1,0,.08c-.43,0-.88,0-1.32,0l-1.33-.05-2.65-.09c-1.77-.07-3.53-.13-5.31-.14C477.76,103.87,477.77,103.73,477.86,103.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.69,126.27c3.29,4.55,12.06,5.28,34,9.19,3,.54,12.61-19.82,9.4-20.57-4-.94-19.93-3.7-21.11-3.76C462.94,110.67,448.45,123.19,450.69,126.27Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.67,114s9.28,1.24,13.95,3.4a33.25,33.25,0,0,1,12.1,10.2c3.41,4.66,8.44,18.29,4.77,20.43-3.33,1.93-7.77-12.26-7.77-12.26s6.92,13.72,2.49,15.31-8.65-15.18-8.65-15.18,6.79,14.26,2,15.18c-3.65.69-8.32-14.28-8.32-14.28s5.75,12.29,2,13.17c-4.11,1-9.29-12.58-9.29-12.58-9.83.62-14.77-3.1-18-6.17C474.19,130.45,489.67,114,489.67,114Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.64,130.84c.87,1.58,1.76,3.18,2.49,4.83s1.39,3.34,2,5.05a30.16,30.16,0,0,1,1.58,6.88,67.35,67.35,0,0,0-4-11.75c-.73-1.65-1.37-3.33-2.1-5C510.56,130.82,510.62,130.8,510.64,130.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.62,133.35c1,2.07,2.11,4.09,3.05,6.2s1.62,4.18,2.4,6.35c.06.16-.05.14-.12,0-.86-2.13-1.83-4-2.72-6.15s-1.7-4.28-2.66-6.36C504.55,133.34,504.6,133.32,504.62,133.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.06,134.58a51.71,51.71,0,0,1,3.94,9.84c.05.17-.09.12-.15,0-1.25-3.29-2.2-5.88-3.9-9.73C498.93,134.58,499,134.52,499.06,134.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.34,146.18a17.47,17.47,0,0,0,2,2.35,7.45,7.45,0,0,0,1.21.95,2.17,2.17,0,0,0,1.39.4,1.33,1.33,0,0,0,1-.91,4.28,4.28,0,0,0,.22-1.48,12.84,12.84,0,0,0-.4-3l-.48-1.93.86,1.79a34.38,34.38,0,0,0,1.73,3.15,12.81,12.81,0,0,0,2.19,2.74,1.67,1.67,0,0,0,1.38.53,1.9,1.9,0,0,0,1.24-.87,5.62,5.62,0,0,0,.08-3.34l-.3-2,.93,1.82a15.2,15.2,0,0,0,1.93,3,5.7,5.7,0,0,0,1.28,1.14,1.54,1.54,0,0,0,1.43.23,1.66,1.66,0,0,0,.92-1.14,5.55,5.55,0,0,0,.22-1.7,16.19,16.19,0,0,0-.47-3.52l-.83-3.5,1.52,3.25a13.85,13.85,0,0,0,1.18,2,4.91,4.91,0,0,0,1.6,1.55,1.15,1.15,0,0,0,.9.09,1.77,1.77,0,0,0,.77-.62,4.08,4.08,0,0,0,.6-2.13,15,15,0,0,0-.68-4.68q-.66-2.33-1.45-4.61a34.67,34.67,0,0,0-4.21-8.65,35.3,35.3,0,0,0-6.76-6.89,35.64,35.64,0,0,1,7,6.68,33.89,33.89,0,0,1,4.45,8.67c.56,1.52,1.09,3.06,1.54,4.62a15.47,15.47,0,0,1,.74,4.89,4.82,4.82,0,0,1-.7,2.49,2.41,2.41,0,0,1-1.1.88,1.84,1.84,0,0,1-1.44-.1,5.56,5.56,0,0,1-1.89-1.77,14.4,14.4,0,0,1-1.26-2.15l.69-.25a15,15,0,0,1,.5,3.72,6.41,6.41,0,0,1-.27,1.92,2.41,2.41,0,0,1-1.35,1.57,2.26,2.26,0,0,1-2.06-.29,6.37,6.37,0,0,1-1.43-1.3,15.81,15.81,0,0,1-2-3.16l.62-.19a15.68,15.68,0,0,1,.21,1.84,3.74,3.74,0,0,1-.39,1.91,2.47,2.47,0,0,1-1.65,1.13,1.53,1.53,0,0,1-1.06-.13,3.64,3.64,0,0,1-.82-.54,13,13,0,0,1-2.24-2.92,31,31,0,0,1-1.69-3.23l.39-.13a12.67,12.67,0,0,1,.34,3.13,4.71,4.71,0,0,1-.31,1.57,1.57,1.57,0,0,1-1.23,1,2.35,2.35,0,0,1-1.51-.48,7.8,7.8,0,0,1-1.2-1A17.5,17.5,0,0,1,497.34,146.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.28,113.59c1.46-.92,5.58-3.09,9.64-2.49,0,0,0,.07,0,.07a26.55,26.55,0,0,0-9.61,2.48A0,0,0,0,1,463.28,113.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542,107.51a18.66,18.66,0,0,1,19.27-3.94l-11.12,10.5,3.56,8.08,7.86,4,11.14-10.51A18.69,18.69,0,1,1,542,107.51Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.51,208.41a18.7,18.7,0,0,1-19.28,4l11.12-10.5-3.56-8.09-7.86-4L458.8,200.26a18.69,18.69,0,1,1,30.71,8.15Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 508.95,
    y: 111.05,
    width: 16.65,
    height: 90.88,
    transform: "translate(758.55 640.08) rotate(-133.35)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 513.85,
    y: 137.78,
    width: 6.86,
    height: 37.43,
    transform: "translate(758.55 640.08) rotate(-133.35)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.39,74c12.34,8.61,31,25.78,32.57,33.59,1.58,8-5,29.43-8.57,36.65-1.49,3-26.08-5.31-24.57-8.57,3.08-6.64,9.56-22.11,9.33-24.29s-9.9-18.9-15.14-28.56C487.61,67.35,493.67,67.93,502.39,74Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.42,132.15S499.34,141.06,497,147c-1.34,3.32-3.12,9.22-3,12.11.2,4.32,3.81,22.26,8.18,21.47,4-.7-1.1-15.72-1.1-15.72s3.76,15.61,8.36,13.88-3.36-17.94-3.36-17.94,4.22,15.95,8.69,13.42c3.37-1.91-3-17-3-17s3.73,13.68,7.29,11.86c3.93-2-1.1-16.3-1.1-16.3,8.26-6.14,10.61-11.66,11.09-16.27C529,136.52,511.18,132.92,503.42,132.15Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.4,159.56c.37,1.84.74,3.72,1.28,5.53s1.14,3.6,1.85,5.35a31,31,0,0,0,3.39,6.55c-2.18-3.81-4.21-10.26-4.75-12.07s-1.16-3.58-1.7-5.39A0,0,0,0,0,499.4,159.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.9,157.49c0,2.63,2,9.82,4.12,13.68.09.17.14.09.08-.09-.75-2.28-3.51-11.3-4.15-13.61C505.94,157.44,505.9,157.46,505.9,157.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.16,154.72a29,29,0,0,0,3.5,10.5c.09.16.15,0,.09-.14-1.23-3.47-2.22-6.18-3.47-10.39A.06.06,0,0,0,511.16,154.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.5,86.15l-19.65,7.94s-7.09-12.26-9.55-19.87c-1.37-4.27,1.14-6.39,4.81-4.68C509,75.52,520.5,86.15,520.5,86.15Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.09,77.78a7,7,0,0,0-.64,1.91,7.53,7.53,0,0,0-.12,2,7.11,7.11,0,0,0,.64-1.92A7.46,7.46,0,0,0,509.09,77.78Zm-13.7-6.36a7.14,7.14,0,0,0-2-.13,7.11,7.11,0,0,0,1.92.64,6.73,6.73,0,0,0,2,.12A7.14,7.14,0,0,0,495.39,71.42Zm11.74,19.85a2.3,2.3,0,0,0,.32.15l.43-.17A4.73,4.73,0,0,0,507.13,91.27Zm-8.82-9a6.82,6.82,0,0,0-1.51,1.34,7.25,7.25,0,0,0,1.8-.91,6.81,6.81,0,0,0,1.51-1.33A6.9,6.9,0,0,0,498.31,82.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.54,90.29a134.91,134.91,0,0,1,16.08-6.47s.09.1.06.12c-4.29,2-13.11,5.41-16.07,6.52C500.56,90.49,500.48,90.31,500.54,90.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502,93.63a5,5,0,0,1-1,.38,15.37,15.37,0,0,1-1.2-2.06c-.58-1.17-1.19-2.33-1.78-3.5-1.17-2.33-2.48-4.58-3.74-6.86,0-.06-.15,0-.12,0,.5,1.19,1,2.36,1.54,3.52l-.05-.07-1-1.44s-.1,0-.07,0l1,1.48L496,86c.56,1.2,1.15,2.4,1.78,3.58s2.53,4.86,3,4.91a14.26,14.26,0,0,0,1.27-.69C502.1,93.74,502.06,93.59,502,93.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.34,146c.83-2.2,1.72-4.37,2.62-6.53l2.75-6.46,5.67-12.84c-.64,2.25-1.46,4.45-2.31,6.64s-1.77,4.34-2.68,6.5-1.9,4.28-2.91,6.4S498.45,144,497.34,146Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.49,67.2c3.73.22,4.28,4.15,2.44,8.2S486.8,81,485,80.82s-3.58-2-2.3-6.71C484.31,68.11,487.24,67.07,489.49,67.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.27,69.48c.11.86-1.76,7.44-5.46,8.63-1.2.38-3.59-6.1-3.59-6.1l-.29-.44-4-6.14,6-8,.89-1.09s1,1.75,2.18,3.94c.06.1.11.21.17.32s.14.23.2.35c.19.32.37.66.55,1s.27.5.41.78l.41.8A46.71,46.71,0,0,1,491.27,69.48Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487,60.3a14.66,14.66,0,0,1-5.06,11.27l-4-6.14,6-8,.89-1.09S485.79,58.11,487,60.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.86,57.57c1.12,12.8,8.92,13.57,11.68,13.32,2.51-.22,11-1.3,11.21-14.15s-6.1-16.37-11.86-16.16S463.73,44.76,464.86,57.57Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.14,55.45a7.59,7.59,0,0,0,.84-.3,1.43,1.43,0,0,0,.79-.47.45.45,0,0,0-.08-.55,1.11,1.11,0,0,0-1.14-.11,1.65,1.65,0,0,0-.95.73A.48.48,0,0,0,467.14,55.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.35,54.37c-.31,0-.59,0-.89-.06a1.46,1.46,0,0,1-.89-.24.46.46,0,0,1-.08-.55,1.12,1.12,0,0,1,1.07-.42,1.69,1.69,0,0,1,1.12.44A.49.49,0,0,1,475.35,54.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.1,57.81s.07,0,.08.07c.07.88.3,1.86,1.12,2.06,0,0,0,.05,0,.05C474.32,60,474,58.65,474.1,57.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.77,56.82c1.39-.27,1.82,2.52.54,2.77S473.61,57,474.77,56.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.34,56.88c.27.12.55.36.85.34s.56-.35.74-.66c0,0,0,0,.05,0,.09.53,0,1.12-.59,1.28s-1-.26-1.18-.77C475.17,57,475.23,56.83,475.34,56.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.06,58.22s-.06.05-.06.09c.17.86.22,1.87-.51,2.28,0,0,0,.06,0,0C469.43,60.35,469.35,59,469.06,58.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.14,57.44c-1.41.13-1.06,2.93.24,2.82S469.32,57.34,468.14,57.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.58,57.7c-.21.18-.39.47-.66.52s-.56-.21-.8-.48c0,0,0,0,0,0,.06.53.3,1.07.83,1.11s.77-.47.83-1C467.75,57.77,467.66,57.63,467.58,57.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.56,64.56c-.17.24-.32.56-.62.65a2.44,2.44,0,0,1-1,0,0,0,0,0,0,0,0,1.19,1.19,0,0,0,1.18.25,1,1,0,0,0,.53-.9A0,0,0,0,0,475.56,64.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.07,61.86s0,1.33.09,1.94a3.31,3.31,0,0,0,3.07-1.45c0-.06-.05-.12-.1-.07a4.41,4.41,0,0,1-2.55,1.14c-.07-.16.06-2.27,0-2.26a5.45,5.45,0,0,0-1.34.51c-.1-2.76.25-5.51.12-8.26a.09.09,0,0,0-.17,0,45,45,0,0,0-.51,8.89C469.64,62.64,470.84,62,471.07,61.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472,63.62a3.2,3.2,0,0,0,1.42.77,1.49,1.49,0,0,0,.88-.08c.59-.27.52-.85.32-1.32a3.38,3.38,0,0,0-.4-.7A4.14,4.14,0,0,1,472,63.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.41,64.39a1.49,1.49,0,0,0,.88-.08c.59-.27.52-.85.32-1.32A1.5,1.5,0,0,0,473.41,64.39Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.18,57.91c-2.3.8-4.07-4.48-4.07-4.48s-10.45.45-13.06-7.57a14.23,14.23,0,0,1-5.37,9.1s-1.55-9.88,5.2-13.16c0,0,8.46-4.91,14.94,1S488.72,57.36,487.18,57.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.88,45.27a9.2,9.2,0,0,0,1.26,3.64,9.44,9.44,0,0,0,2.61,2.91,7.81,7.81,0,0,0,.83.53l.42.26.44.2.9.39.94.27.47.13.48.08,1,.15c.65,0,1.29,0,1.93,0-.63-.13-1.26-.19-1.88-.33l-.93-.22-.45-.12a4,4,0,0,1-.45-.16l-.88-.32c-.29-.12-.56-.27-.84-.4l-.42-.21-.4-.25a6.85,6.85,0,0,1-.77-.51,11.18,11.18,0,0,1-2.59-2.68,11,11,0,0,1-.94-1.63A11.81,11.81,0,0,1,469.88,45.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.7,57.49s2.06-4.44,4-3.77.9,6.76-1.07,7.92a2.17,2.17,0,0,1-3.07-.65Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M489.38,55.46s.05,0,0,0a5.53,5.53,0,0,0-2.2,3.88,1.2,1.2,0,0,1,1.71-.63s0,.08,0,.08a1.34,1.34,0,0,0-1.37.72,6.47,6.47,0,0,0-.49,1.29c0,.15-.3.12-.27,0v0C486.4,58.9,487.39,56,489.38,55.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.33,61.29a.52.52,0,1,0,1-.26.51.51,0,0,0-.63-.37A.52.52,0,0,0,487.33,61.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.36,60.15a.38.38,0,1,0,.73-.19.38.38,0,0,0-.46-.27A.38.38,0,0,0,488.36,60.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.12,55.13l.74-.26a.28.28,0,0,0,.17-.35h0a.28.28,0,0,0-.35-.17l-.74.26a.28.28,0,0,0-.17.35h0A.28.28,0,0,0,490.12,55.13Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.29,55.91l.77-.09a.27.27,0,0,0,.24-.31h0a.27.27,0,0,0-.3-.24l-.77.1a.26.26,0,0,0-.24.3h0A.27.27,0,0,0,490.29,55.91Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.46,55.16l2.19,2.15,2.78-4.19-1-.95Zm1.23.11,2.57-2.15.22.22-2,2.68Z",
    style: {
      fill: "#FFC727"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.65,455.22c-1.89.59-55.56-.56-57.58-1.9-.77-.5-1.06-8.33-1.14-17.8q0-3.06,0-6.3c0-2.53,0-5.11.05-7.6.14-11.21.48-21.08.48-21.08l34.94.65L172,422.27l-.14,7.6-.3,6.3s20.35,9.63,22.4,11.34S197.53,454.64,195.65,455.22Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.65,455.22c-1.89.59-55.56-.56-57.58-1.9-.77-.5-1.06-8.33-1.14-17.8q0-3.06,0-6.3c0-2.53,0-5.11.05-7.6l35,.65-.14,7.6-.3,6.3s20.35,9.63,22.4,11.34S197.53,454.64,195.65,455.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.81,455.3c-1.23.38-24.09,0-40.73-.61-3.85-.16-7.38-.33-10.21-.5-3.92-.26-6.54-.52-7-.8-.94-.62-1.18-12.11-1.17-24.23l35.12.65-.3,6.33s20.47,9.69,22.54,11.4S197.7,454.7,195.81,455.3Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.08,453.13c-9-.42-45.55-1.24-54.52-1-.07,0-.07.06,0,.06,8.95.61,45.47,1.14,54.52,1.06C195.27,453.27,195.27,453.14,195.08,453.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.88,434.16c-3.54-.74-7.91-.29-10.68,2.19-.11.1,0,.25.14.21a50,50,0,0,1,10.52-1.95A.23.23,0,0,0,172.88,434.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.42,435.76c-3.55-.74-7.91-.29-10.69,2.19-.11.1,0,.25.15.22a49.42,49.42,0,0,1,10.52-2A.23.23,0,0,0,175.42,435.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,437.37c-3.55-.75-7.92-.29-10.69,2.19-.11.09,0,.24.15.21a50,50,0,0,1,10.51-1.95A.23.23,0,0,0,178,437.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.49,439c-3.54-.74-7.91-.29-10.68,2.19-.11.1,0,.25.14.21a50,50,0,0,1,10.52-1.95A.23.23,0,0,0,180.49,439Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.63,426.07c-1.35-2-4-1.15-5.49.07a19.06,19.06,0,0,0-5.66,8,.11.11,0,0,0,.08.14c0,.27.25.56.55.45,3-1,6.26-1.75,8.82-3.66C179.42,430,180.92,427.92,179.63,426.07Zm-6.34,6.22c-1.45.54-2.91,1-4.34,1.6,1.11-1.57,2.15-3.17,3.41-4.63a21.35,21.35,0,0,1,1.93-2c1.08-.94,5.32-2.91,4.61,1C178.51,430.4,175,431.64,173.29,432.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.45,433.05c2.91,1.32,6.29,1.32,9.4,1.69a.44.44,0,0,0,.44-.56.09.09,0,0,0,.05-.14,19,19,0,0,0-7.24-6.65c-1.74-.86-4.48-1.1-5.39,1.11S157.76,432.28,159.45,433.05Zm-1.55-2.57c-1.53-3.65,3-2.64,4.29-2a19.73,19.73,0,0,1,2.31,1.54c1.55,1.15,2.9,2.49,4.32,3.78-1.52-.27-3-.41-4.58-.63C162.42,433,158.74,432.49,157.9,430.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.34,455.11c-4.52-.12-9.09-.27-13.27-.43-3.85-.14-7.37-.31-10.21-.49-3.91-.26-6.53-.52-7-.8-.82-.55-1.11-9.42-1.15-19.76C144.72,439,160.38,449.66,168.34,455.11Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175,435.73l-39.88,0s2.19-89.76,1.76-91.85c-1-5-23.71-84.13-23.71-84.13l31.49.54,10.76.19s-.93,13.18-.55,14.57c5.26,19.2,15.53,52,17.63,64.14C176.12,360.29,175,435.73,175,435.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.7,429.07c-6.22-.16-28.26-.82-36.55-.2-.06,0-.06.11,0,.12,2.84.46,30.32.33,36.54.25A.09.09,0,1,0,173.7,429.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,341.94c-1.19-4.86-10.07-35.09-12.79-44.63s-5.27-19.14-7.61-28.78c-.3-1.22-.6-2.44-.92-3.66,0-.1-.18-.05-.16.05.9,4.85,2.08,9.66,3.22,14.47s2.36,9.59,3.64,14.36q3.86,14.37,8.42,28.55c1.53,4.7,4,14.37,5.37,19.13s-.85,82.93-.71,84.2a.29.29,0,0,0,.57,0C139.2,416.42,141.17,346.73,140,341.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.66,260.32s-7.7,84-7.79,83.59c-1-4.83-22.31-79.25-23.65-83.9l-.06-.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.29,459.82c-1.89.59-55.56-.56-57.58-1.9-.76-.5-1-8.33-1.13-17.8q0-3.06,0-6.3c0-2.53,0-5.11,0-7.6.14-11.21.48-21.08.48-21.08l34.94.65-.4,21.08-.15,7.6-.3,6.3s20.35,9.63,22.41,11.34S156.18,459.24,154.29,459.82Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.29,459.82c-1.89.59-55.56-.56-57.58-1.9-.76-.5-1-8.33-1.13-17.8q0-3.06,0-6.3c0-2.53,0-5.11,0-7.6l35,.65-.15,7.6-.3,6.3s20.35,9.63,22.41,11.34S156.18,459.24,154.29,459.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.45,459.9c-1.23.38-24.09,0-40.73-.61-3.85-.16-7.37-.33-10.21-.5-3.91-.26-6.54-.52-7-.8-.93-.62-1.17-12.11-1.16-24.23l35.11.65-.3,6.33s20.47,9.69,22.54,11.4S156.35,459.3,154.45,459.9Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.73,457.73c-9-.42-45.56-1.24-54.53-1-.07,0-.07.06,0,.06,9,.61,45.47,1.14,54.52,1.06C153.91,457.87,153.92,457.74,153.73,457.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.53,438.76c-3.55-.74-7.92-.29-10.69,2.19-.11.1,0,.25.15.21a50,50,0,0,1,10.51-2A.23.23,0,0,0,131.53,438.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.06,440.36c-3.54-.74-7.91-.29-10.68,2.19-.11.1,0,.25.14.22a49.42,49.42,0,0,1,10.52-2A.23.23,0,0,0,134.06,440.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.6,442c-3.55-.74-7.91-.29-10.69,2.19-.11.09,0,.24.15.21a50,50,0,0,1,10.52-1.95A.23.23,0,0,0,136.6,442Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.14,443.57c-3.55-.74-7.92-.29-10.69,2.19-.11.1,0,.25.15.21a50,50,0,0,1,10.51-2A.23.23,0,0,0,139.14,443.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.28,430.67c-1.36-2-4-1.15-5.5.07a18.92,18.92,0,0,0-5.65,8c0,.07,0,.11.08.13a.44.44,0,0,0,.55.45c3-1,6.25-1.75,8.81-3.66C138.07,434.59,139.56,432.52,138.28,430.67Zm-6.35,6.22c-1.45.54-2.91,1-4.33,1.6,1.11-1.57,2.14-3.17,3.4-4.63a20.25,20.25,0,0,1,1.94-2c1.07-.94,5.31-2.91,4.6,1C137.15,435,133.65,436.24,131.93,436.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.1,437.65c2.9,1.32,6.28,1.32,9.39,1.69a.44.44,0,0,0,.44-.56.09.09,0,0,0,0-.14,19,19,0,0,0-7.24-6.65c-1.74-.86-4.48-1.1-5.38,1.11S116.4,436.89,118.1,437.65Zm-1.56-2.57c-1.52-3.65,3-2.64,4.29-1.95a18.93,18.93,0,0,1,2.31,1.54c1.55,1.15,2.9,2.49,4.32,3.78-1.52-.27-3-.41-4.57-.63C121.07,437.56,117.39,437.09,116.54,435.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.53,439.79l-38.69-.71s10.86-139.56,9.51-146.95c-2.21-12.1-.33-25.92,5.5-32.48l37.7.7s.55,10.6-3.46,16.85c0,0-3.57,2.17-5.31,3.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.47,432.92c-5.87-.26-4.18-.26-10-.46-2.88-.1-21.75-.71-24.45-.33a.06.06,0,0,0,0,.12c2.68.51,21.56.79,24.43.83,5.87.09,4.19,0,10.06,0A.09.09,0,0,0,131.47,432.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.48,275.54a72.51,72.51,0,0,0-10.72,6.08.13.13,0,0,0,.13.22c3.62-1.92,7.32-3.78,10.83-5.88A.24.24,0,0,0,145.48,275.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.69,274.91a16.77,16.77,0,0,0-.56,2.22,4.73,4.73,0,0,0-.14,1.79c0,.12.18.11.23,0a6,6,0,0,0,.62-1.79c.2-.69.4-1.38.58-2.07A.38.38,0,0,0,140.69,274.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.41,271.27c.12-.63.23-1.25.36-1.88s.3-1.29.38-1.95c0-.1.18-.07.16,0-.11.63-.14,1.28-.2,1.91s-.13,1.28-.21,1.91c-.14,1.19-.37,2.38-.62,3.55a4.06,4.06,0,0,0,1.74-.69,3.29,3.29,0,0,0,1-1.79c.19-.72.36-1.45.57-2.16a13.38,13.38,0,0,0,.6-2.4c0-.11.18-.07.16,0a25.71,25.71,0,0,1-1,5.06,2.82,2.82,0,0,1-1,1.67,5.41,5.41,0,0,1-2.12.58c-.09.05-.21,0-.2-.1A36.75,36.75,0,0,1,140.41,271.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.48,291.76c-.21-2.78-.61-5.53-.87-8.31a51.37,51.37,0,0,1,1.32-16.57c0-.1-.14-.15-.16-.05A61.55,61.55,0,0,0,108,281.38c.15,4.88.92,9.72.91,14.62s-.49,9.91-.9,14.85-.83,9.94-1.24,14.92c-1.66,20-3.21,40-4.8,60q-.66,8.37-1.29,16.74c-.43,5.68-1.09,19.68-1.41,25.37,0,.49.71.47.76,0,1-10,1.87-28.41,2.69-38.45s1.59-19.89,2.38-29.83,1.57-19.88,2.35-29.82c.39-5,.76-10,1.14-14.92s.83-9.9,1-14.87A71.86,71.86,0,0,0,109.48,291.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.3,266.78a.09.09,0,0,0-.15,0,6.48,6.48,0,0,0-.39,2,14.83,14.83,0,0,1-.56,2.18,8.78,8.78,0,0,1-2.33,3.76c-2.42,2.18-5.61,2.94-8.69,3.63-.11,0-.07.19,0,.2a13.8,13.8,0,0,0,5.36-.74,11.19,11.19,0,0,0,4.16-2.23,7.73,7.73,0,0,0,2.31-4,14,14,0,0,0,.3-2.43c0-.39,0-.79,0-1.18A3,3,0,0,0,123.3,266.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.58,208.21c5.67,18.25,17.13,36,20.68,38.42,5.5,3.75,31.58,7,40.15,6,2.81-.33,1.78-19.81-.8-21.4s-27.91-1.9-29.63-2.59c-.92-.36-14.43-15.95-22-24.09C146.85,196.93,143.86,202.67,145.58,208.21Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.45,216.2,151,227.88s-6.33-13.68-6.83-22,3.44-7.37,8.05-3.37S165.45,216.2,165.45,216.2Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.45,216.2l-5.16,4.17L151,227.88s-6.33-13.68-6.83-22c-.41-6.74,2.12-7.39,5.56-5.25a19.61,19.61,0,0,1,2.49,1.88C156.81,206.52,165.45,216.2,165.45,216.2Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.87,214.53c.1-.08.08-.17,0-.1a126,126,0,0,0-12.16,9.79,0,0,0,0,0,0,.05C152.92,222.92,161.81,215.34,162.87,214.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.29,220.37,151,227.88s-6.33-13.68-6.83-22c-.41-6.74,2.12-7.39,5.56-5.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.67,264c.1.16,54.83,11.18,55.44,10.71.85-.65,1.86-57.34-4.69-70.92-1.64-3.4-9.06-6.87-12.86-4.41-11,7.12-14.31,14.18-17.86,19.8a179.37,179.37,0,0,0-9.61,18.92C107.47,250.45,102.32,263.4,102.67,264Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.29,200.65l-8.84-1.71C144,198,147.64,199,150.29,200.65Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154,205.18l-17-3.3c.35-.27.72-.54,1.1-.81l15.43,3C153.7,204.4,153.85,204.78,154,205.18Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.2,209.22,133.33,205c.3-.29.61-.57.93-.85l20.67,4C155,208.48,155.12,208.85,155.2,209.22Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M156,213.18l-25.78-5q.38-.44.78-.87l24.81,4.8C155.88,212.46,156,212.82,156,213.18Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.61,217.1l-29-5.62.67-.9L156.46,216C156.52,216.39,156.57,216.74,156.61,217.1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M157.09,221l-31.72-6.15c.19-.3.38-.61.58-.91l31,6Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M157.48,224.88l-34.19-6.63.56-.92,33.53,6.5C157.41,224.18,157.44,224.52,157.48,224.88Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M157.79,228.75l-36.57-7.09.54-.93,36,7C157.74,228.05,157.76,228.4,157.79,228.75Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M158,232.6l-38.68-7.49c.16-.32.32-.63.49-.94L158,231.56Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M158.25,236.44l-40.65-7.87c.15-.32.31-.63.47-.94l40.13,7.77C158.21,235.75,158.23,236.09,158.25,236.44Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.41,240.28l-42.5-8.23.45-.94,42,8.13C158.39,239.59,158.4,239.93,158.41,240.28Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M158.54,244.11l-44.27-8.57c.14-.32.29-.64.44-.95l43.8,8.48Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M158.63,247.93l-46-8.9.42-.92s0,0,0,0l45.51,8.81C158.62,247.24,158.63,247.59,158.63,247.93Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M158.7,251.75l-47.6-9.22c.15-.31.29-.63.43-.95l47.15,9.14C158.69,251.07,158.69,251.41,158.7,251.75Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M158.72,254.53v1L109.57,246c.14-.31.27-.63.42-.95Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M158.73,258.33c0,.35,0,.7,0,1l-50.65-9.81.41-1Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M158.71,262.14c0,.35,0,.69,0,1L106.6,253.08l.4-1Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M158.64,265.93c0,.35,0,.7,0,1l-53.44-10.35.38-1Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M158.53,269.72c0,.36,0,.7,0,1l-54.67-10.59.36-1Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M158.32,273.48c0,.46-.09.8-.13,1l-55.53-10.76c0-.21.13-.55.26-1Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M149,208.78c-2.36,0-7.11-4.51-8.91-8.28-.12-.26.41-2.88.91-6.09.29-1.95.57-4.13.68-6.13L154.05,192a31.86,31.86,0,0,0-1.64,7.63,4.44,4.44,0,0,0,0,.83s0,.09,0,.14C152.63,202.22,152.65,208.72,149,208.78Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.45,200.5a.71.71,0,0,0,0,.14,9.38,9.38,0,0,1-1.3,0c-7.28-.57-8.6-9.65-8.82-12.14L154.06,192a31.64,31.64,0,0,0-1.65,7.63A5.5,5.5,0,0,0,152.45,200.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,175.59c-1,4.58,2.58,17.22,6,19.8,5,3.73,12.52,3.44,15.55-2.39,2.93-5.66-1.95-22.06-5.72-24.34C148.26,165.3,139.4,168.83,138,175.59Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,181.81s-.06.06,0,.09c.29.83.49,1.84-.18,2.36,0,0,0,.06,0,.05C152.64,183.88,152.36,182.55,152,181.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.91,181.17c-1.38.33-.62,3.08.67,2.77S152.08,180.89,150.91,181.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.44,180.4s.07,0,.08,0c.21.86.6,1.81,1.45,1.88,0,0,0,0,0,0C157,182.51,156.5,181.24,156.44,180.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,179.29c1.34-.48,2.21,2.24,1,2.69S155.83,179.7,157,179.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.48,180.21c.35-.2.63-.44,1-.67s.68-.43.85-.87A.6.6,0,0,0,151,178a1.5,1.5,0,0,0-1.5.26,2.19,2.19,0,0,0-1,1.25A.64.64,0,0,0,149.48,180.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.61,178c-.4,0-.77,0-1.17,0a1.91,1.91,0,0,1-1.2-.21.61.61,0,0,1-.17-.72,1.52,1.52,0,0,1,1.36-.67,2.18,2.18,0,0,1,1.52.45A.65.65,0,0,1,157.61,178Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.86,190.09a1.31,1.31,0,0,0,.86.3,2.21,2.21,0,0,0,.85-.46s.06,0,.05,0a1.18,1.18,0,0,1-1,.76,1,1,0,0,1-.88-.56S152.82,190.07,152.86,190.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.05,187.3a3,3,0,0,0,2.29.75,3.9,3.9,0,0,0,1.06-.25l.19-.07.18-.08a.24.24,0,0,0,.12-.24h0a.2.2,0,0,0,0-.08h0l0-.07c-.17-.67-.51-1.64-.51-1.64.28.05,1.65.26,1.54-.08a45.45,45.45,0,0,0-3.57-8.46c0-.09-.19,0-.15.06.81,2.72,2.1,5.27,3,8a5,5,0,0,0-1.48,0c-.09,0,.69,1.88.74,2.18a0,0,0,0,1,0,0,4.17,4.17,0,0,1-3.26-.09C153,187.17,153,187.24,153.05,187.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.92,187.58a3.51,3.51,0,0,1-1.08,1.45,1.58,1.58,0,0,1-.93.32c-.73,0-.92-.61-.94-1.18a3.86,3.86,0,0,1,.08-.9A4.65,4.65,0,0,0,155.92,187.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.84,189a1.58,1.58,0,0,1-.93.32c-.73,0-.92-.61-.94-1.18A1.66,1.66,0,0,1,154.84,189Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,184.94c.81-.6,2-3.82,2.49-5.15s-.56-7.14-.93-8.86a9.39,9.39,0,0,0-2.52,4.61C137.58,177.59,138,181.27,139,184.94Z",
    style: {
      fill: "#263238",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.64,173.21a4.53,4.53,0,0,1-3.7,2.44,4.66,4.66,0,0,1-4.12-1.89s-.09,0-.06,0A4.61,4.61,0,0,0,149,176a4.67,4.67,0,0,0,3.78-2.76A.06.06,0,1,0,152.64,173.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.51,163.31a7.17,7.17,0,0,0-5.13,4.59,5.13,5.13,0,0,0,.26,3.36c0,.05.11,0,.1,0a5.62,5.62,0,0,1,1.43-5.54,7.24,7.24,0,0,1,6.07-2.19,4.57,4.57,0,0,1,2.84,1.36c.07.09.25,0,.19-.1C150.2,163.31,147.83,162.72,145.51,163.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.75,165.43a5.83,5.83,0,0,0-3.13-2.5c-1.8-.61-3.55-.05-5.28.54-.05,0,0,.09,0,.07a8.09,8.09,0,0,1,4.55-.52,5.68,5.68,0,0,1,3.21,2.11,5.58,5.58,0,0,1-.69,7.28,5.68,5.68,0,0,1-4.25,1.45c-.06,0-.09.09,0,.1a5.7,5.7,0,0,0,5.59-8.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.84,178.32s-3.5-4-2.06-7.19c.82-1.77,4.71-2.44,4.71-2.44a7.12,7.12,0,0,1,3.76-3.95c3.05-1.46,7.31-.45,7.31-.45s2.66-2.45,5.89-1.46c4.51,1.38,5.39,7.57,1.81,10.44-2.51,2-6.91.38-6.91.38-.35.14-3.61,3.27-7.23.55,0,0-1.85,2.58-4.26,1.61A3.44,3.44,0,0,1,137.84,178.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.7,185.82s-3.37-3.83-5.13-2.58,1.08,7,3.38,7.59a2.26,2.26,0,0,0,2.88-1.54Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.43,184.87a0,0,0,0,0,0,.06,5.7,5.7,0,0,1,3.33,3.23,1.24,1.24,0,0,0-1.89-.13s0,.09,0,.08a1.39,1.39,0,0,1,1.58.31,6.51,6.51,0,0,1,.86,1.15c.09.13.33,0,.26-.13v0C141.41,187.43,139.57,184.83,137.43,184.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.93,
    y: 205.94,
    width: 107.67,
    height: 71.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.76,277.43v-.18l0-71.48h.18l107.85,0,0,71.66h-.18Zm.34-71.3,0,70.94,107.31,0,0-70.93Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,241.58a12.23,12.23,0,1,1-12.23-12.22A12.23,12.23,0,0,1,222,241.58Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.61 246.75 204.61 236.42 217.53 241.58 204.61 246.75",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.94,
    y: 271.66,
    width: 107.67,
    height: 5.57,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.46,
    y: 273.62,
    width: 90.62,
    height: 1.65,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.92,
    y: 272.7,
    width: 3.52,
    height: 3.52,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.74,
    y: 273.33,
    width: 0.67,
    height: 2.27,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.95,
    y: 273.33,
    width: 0.67,
    height: 2.27,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.53,
    y: 272.67,
    width: 3.52,
    height: 3.52,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.06,
    y: 274.01,
    width: 0.69,
    height: 0.85,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.52 275.41 255.48 274.86 255.48 274.01 256.52 273.46 256.52 275.41",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--u5Zjqx--inject-17"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257,273.78l.16-.16a1.18,1.18,0,0,1,.32.65,1.12,1.12,0,0,1-.32,1l-.16-.16a.91.91,0,0,0,.27-.65A.93.93,0,0,0,257,273.78Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.87,274.92l-.16-.15a.49.49,0,0,0,.14-.34.45.45,0,0,0-.14-.33l.16-.16A.69.69,0,0,1,256.87,274.92Z",
    style: {
      fill: "#a6a6a6"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 258.73,
    y: 272.67,
    width: 3.52,
    height: 3.52,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.29,
    y: 273.24,
    width: 1.45,
    height: 1.45,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.25,
    y: 274.24,
    width: 1.45,
    height: 1.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.44,274.46a1.87,1.87,0,0,0,.19.82H162.47v-1.66h17.18A1.88,1.88,0,0,0,179.44,274.46Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.21,274.46a1.74,1.74,0,0,1-.19.82,1.89,1.89,0,0,1-3.39,0,1.9,1.9,0,0,1,1.69-2.71,1.9,1.9,0,0,1,1.7,1.06A1.88,1.88,0,0,1,183.21,274.46Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.67,211.39c-5.48,14-3.86,39.71,1.29,45.75,8.09,9.5,21.25,22.36,28.42,24.52,4.18,1.26,12.5-21.89,8.84-23.19-5.77-2.06-21.09-13.32-22.64-15.11s-4.66-19.63-6.52-30.49C138.05,201.07,133.46,204.26,130.67,211.39Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.38,281.66c12.36,5.07,27.09,3.27,29.5,2.42,2.06-.71,3.11-1.1,3.11-1.1,3.72-1.21,4.65-3.33,4.65-3.33s4.7-.14,5.09-3c.45-3.21-6.25-2.39-10.21-4.2-9.06-4.13-20.8-12.54-23.3-14Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,274.81a63.79,63.79,0,0,0,8.14,3.17,64.14,64.14,0,0,0,9.44,1.58c.1,0,.1.16,0,.16A33.92,33.92,0,0,1,179.87,275C179.74,275,179.84,274.75,180,274.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.69,279.92c2.68,1,7.41,2.69,16.31,3,0,0,0,.05,0,.05a30.49,30.49,0,0,1-16.4-2.74C176.43,280.12,176.51,279.86,176.69,279.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.91,266.79c-1-1-.44-1.52,2-1.18s11.9,3.79,12.82.39-12.46-8.05-16.6-8.31a65.31,65.31,0,0,0-10.92.78C171.65,259.9,177.19,263.93,181.91,266.79Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.21,228.64l-18.54,1.47s2.49-14.86,6.76-22,7-4.14,8.55,1.76S143.21,228.64,143.21,228.64Z",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,225.81c.12,0,.15-.1,0-.09a125.53,125.53,0,0,0-15.56,1.22,0,0,0,0,0,0,.07C129.08,227.13,140.69,225.88,142,225.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.26,229.89c-1,.1-1.64.08-2.59.22.66-2.65,1.27-5.3,2-7.93s1.45-5.49,2.3-8.19c0,0,0-.05,0,0-.55,1.41-1.09,2.82-1.61,4.23a17.91,17.91,0,0,1,.53-2.72s0,0-.07,0a16.4,16.4,0,0,0-.64,3.25c-.38,1.09-.75,2.18-1.07,3.3a63.5,63.5,0,0,0-1.85,8.44,16.74,16.74,0,0,0,3-.41C127.36,230,127.35,229.88,127.26,229.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.52,221.88l-.18-1.18h0c0-1.11.05-2.23,0-3.34,0-.06-.08,0-.09,0,0,.86-.06,1.71-.08,2.57-.08-.48-.15-1-.23-1.44-.17-1.08-.46-2.12-.67-3.18,0-.08-.15-.06-.14,0,.12,1.14.17,2.28.33,3.41l.51,3.41c.32,2.16.65,4.34,1.12,6.48l-.25.09c-.07,0-.07.16,0,.16l.38,0a.16.16,0,0,0,.14-.15C143.24,226.42,142.88,224.15,142.52,221.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.83,220.89c-2.69,1.15-2.5-2.69-2.5-2.69s-1.61,5.46-4.84,5.57-2.73-4.53-2.71-4.87c-.08.29-1.69,5.26-5,5s-2.19-4.81-2.12-5.11c-.16.25-2.44,3.46-4.88,2.72-4.19-1.27,1.53-11,.69-14.44l-6-2.66a8.8,8.8,0,0,0,4.7-1.68c2-1.38,3.37-2.32,4.89-2.51a3.22,3.22,0,0,1,3.41,1.76s1.37-2.78,3.95-2.69c1.32.06,2.41,2.22,2.41,2.22a3.83,3.83,0,0,1,3.48-2c1.82.18,2.63,2.32,2.63,2.32s2.12-1.57,3.93-.78C231.51,202.71,231.61,218.43,225.83,220.89Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.22,206.29l-4.63-1.8-.45-.32c-5.08-3.81-5.37-11.93-1.09-10.37,3.25,1.19,4.54,6.92,8,7.65h0Z",
    style: {
      fill: "#ad6359"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.12,202.23s.07-.07.08,0a27.23,27.23,0,0,1-.86,16.2c-.06.17-.36.13-.32-.06A55.61,55.61,0,0,0,224.12,202.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.86,201.47c0-.06.1-.07.11,0a25.59,25.59,0,0,1-2,17.62c-.1.18-.38.25-.28,0C217.35,215.33,218.32,206.53,217.86,201.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.37,219.14c2.64-5.34,3.31-11,3.16-16.9,0-.08.11-.07.13,0,.86,2.87.56,6.64.08,9.56a15.71,15.71,0,0,1-3.19,7.44C208.48,219.32,208.31,219.25,208.37,219.14Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteSetupProject2);
export default __webpack_public_path__ + "static/media/website-setup-project-2.d68a684958b788bcb2d3002f7627695e.svg";
export { ForwardRef as ReactComponent };